export default "__VITE_PUBLIC_ASSET__1b217fa8__"